(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["alert~collapse~config-provider~dropdown~form~grid~index~input~input-number~loading~menu~modal~popcon~7643ae69"],{

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ConfigConsumerProps", function() { return /* binding */ ConfigConsumerProps; });

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/components/empty/index.jsx + 1 modules
var empty = __webpack_require__(44);

// CONCATENATED MODULE: ./src/base/config-provider/renderEmpty.jsx



var RenderEmpty = {
  functional: true,
  inject: {
    configProvider: {
      default: function _default() {
        return ConfigConsumerProps;
      }
    }
  },
  props: {
    componentName: vue_types["a" /* default */].string
  },
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props,
        injections = context.injections;

    function renderHtml(componentName) {
      var getPrefixCls = injections.configProvider.getPrefixCls;
      var prefix = getPrefixCls('empty');

      switch (componentName) {
        case 'Table':
        case 'List':
          return h(empty["default"], {
            attrs: {
              image: empty["default"].PRESENTED_IMAGE_SIMPLE
            }
          });

        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
          return h(empty["default"], {
            attrs: {
              image: empty["default"].PRESENTED_IMAGE_SIMPLE
            },
            "class": "".concat(prefix, "-small")
          });

        default:
          return h(empty["default"]);
      }
    }

    return renderHtml(props.componentName);
  }
};

function renderEmpty_renderEmpty(h, componentName) {
  return h(RenderEmpty, {
    attrs: {
      componentName: componentName
    }
  });
}

/* harmony default export */ var config_provider_renderEmpty = (renderEmpty_renderEmpty);
// EXTERNAL MODULE: ./src/base/locale-provider/index.jsx
var locale_provider = __webpack_require__(65);

// EXTERNAL MODULE: ./src/base/locale-provider/LocaleReceiver.jsx
var LocaleReceiver = __webpack_require__(15);

// CONCATENATED MODULE: ./src/base/config-provider/index.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // import Base from '../base';




function getWatch() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var watch = {};
  keys.forEach(function (k) {
    watch[k] = function (value) {
      this._proxyVm._data[k] = value;
    };
  });
  return watch;
}

var ConfigProvider = {
  name: 'MegConfigProvider',
  props: {
    getPopupContainer: vue_types["a" /* default */].func,
    prefixCls: vue_types["a" /* default */].string,
    renderEmpty: vue_types["a" /* default */].func,
    csp: vue_types["a" /* default */].object,
    autoInsertSpaceInButton: vue_types["a" /* default */].bool,
    locale: vue_types["a" /* default */].object,
    pageHeader: vue_types["a" /* default */].object,
    transformCellText: vue_types["a" /* default */].func
  },
  provide: function provide() {
    var _self = this;

    this._proxyVm = new external_vue_default.a({
      data: function data() {
        return _objectSpread(_objectSpread({}, _self.$props), {}, {
          getPrefixCls: _self.getPrefixCls,
          renderEmpty: _self.renderEmptyComponent
        });
      }
    });
    return {
      configProvider: this._proxyVm._data
    };
  },
  watch: _objectSpread({}, getWatch(['prefixCls', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader', 'transformCellText'])),
  methods: {
    renderEmptyComponent: function renderEmptyComponent(h, name) {
      var renderEmpty = Object(props_util["getComponentFromProp"])(this, 'renderEmpty', {}, false) || config_provider_renderEmpty;
      return renderEmpty(h, name);
    },
    getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
      var _this$$props$prefixCl = this.$props.prefixCls,
          prefixCls = _this$$props$prefixCl === void 0 ? 'meg' : _this$$props$prefixCl;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    },
    renderProvider: function renderProvider(legacyLocale) {
      var h = this.$createElement;
      return h(locale_provider["default"], {
        attrs: {
          locale: this.locale || legacyLocale,
          _ANT_MARK__: locale_provider["ANT_MARK"]
        }
      }, [this.$slots.default ? Object(props_util["filterEmpty"])(this.$slots.default)[0] : null]);
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h(LocaleReceiver["a" /* default */], {
      scopedSlots: {
        default: function _default(_, __, legacyLocale) {
          return _this.renderProvider(legacyLocale);
        }
      }
    });
  }
};
var ConfigConsumerProps = {
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "meg-".concat(suffixCls);
  },
  renderEmpty: config_provider_renderEmpty
};
/* istanbul ignore next */

ConfigProvider.install = function (Vue) {
  // Vue.use(Base);
  Vue.component(ConfigProvider.name, ConfigProvider);
};

/* harmony default export */ var config_provider = __webpack_exports__["default"] = (ConfigProvider);

/***/ })

}]);